import { authenticatedFetch } from '../authenticatedFetch';
import { isHostRdr } from '../urls';
import { getCurrentUser } from './currentUser';
import { getEntitlements } from './entitlements';
import get from 'lodash/get';

let researchFacetsPromise;
let shouldRefetch = false;

window.addEventListener('portfolioChange', () => {
  shouldRefetch = true;
});

export function getResearchFacets() {
  return shouldRefetch ? refetchResearchFacets() : researchFacetsPromise;
}

export function refetchResearchFacets() {
  return (researchFacetsPromise = Promise.all([
    getCurrentUser(),
    getEntitlements(),
  ]).then(([currentUser, entitlements]) => {
    shouldRefetch = false;
    const queryParams = [];
    const homepage = get(currentUser, 'homepage');
    const agentId = get(currentUser, 'agentId');
    //everyone except for Issuer portal users should have the new topics tab.
    //This check should be same as HOME_SHOW_ISSUER_LANDING_PAGE condition in web-client
    const isIssuerPortalUser =
      homepage === 'Issuer Portal' && agentId !== '1248791';
    let endpoint = isHostRdr() ? '/fc/facets/research' : '/facets/research';
    if (!isIssuerPortalUser) {
      queryParams.push('topics=true');
    }
    const features = get(entitlements, 'features.features', []);
    if (features.includes('country_risk_and_industry_research_beta')) {
      queryParams.push('crirbeta=true');
    }
    if (features.includes('sustainable_fitch')) {
      queryParams.push('hasSustainableFitch=true');
    }
    if (queryParams.length > 0) {
      endpoint += `?${queryParams.join('&')}`;
    }
    return authenticatedFetch(endpoint).then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw Error(
          `Facets Request responded with HTTP status ${response.status}`
        );
      }
    });
  }));
}
